export default {
    associate_to_gps_title: "Asociar cámara a un dispositivo gps",
    associate_to_gps_success_message: "Los dispositivos han sido emparejados",
    associate_to_gps_error_message: "El fabricante del dispositivo debe ser diferente de VidFleet y SmartWitness",
    associate_to_gps_vidfleet_device_esn: "ESN de la cámara",
    associate_to_gps_search_gps_device: "Buscar un dispositivo GPS",
    associate_to_gps_alert_message: "El dispositivo ya está emparejado a otro dispositivo, si continúa con la acción se desvinculará automáticamente",
    associate_to_gps_pair: "Emparejar",
    associate_to_gps_search_by: "Buscar un dispositivo GPS por nombre de dispositivo, ESN, IMEI",
}